export default __webpack_public_path__ + "static/media/coolinc.dddfc464.svg";